export const seriesList = [
  "2026 Britcar 24 Presented by Cosworth",
  "AMSOIL USAC Sprint Car 2026 - Season 4",
  "ARCA Menards Series - 2026 Season 4 - Fixed",
  "Advanced Mazda MX-5 Cup by Heusinkveld - 2026 Season 4",
  "Advanced Pro2 Lite Off Road Series - 2026 Season 4",
  "BMW M Power Challenge - 2026 Season 4",
  "BMW M2 Cup by Vero Motion - 2026 Season 4",
  "Big Block Modified Series - 2026 Season 4",
  "Big Block Modified Series - Fixed - 2026 Season 4",
  "CARS Tour Late Model Stocks - 2026 Season 4",
  "CARS Tour Late Model Stocks - Fixed - 2026 Season 4",
  "Caterham 420R Cup - 2026 Season 4",
  "Caterham Academy Challenge - 2026 Season 4",
  "Clio Cup - 2026 Season 4",
  "Creventic Endurance Series - 2026 Season",
  "DIRTcar 305 Sprint Car Series by Fanatec - 2026 Season 4 Fixed",
  "DIRTcar 358 Modified Series - 2026 Season 4",
  "DIRTcar 360 Sprint Car Series - 2026 Season 4",
  "DIRTcar 360 Sprint Car Series - Fixed 2026 Season 4",
  "DIRTcar Class C Dirt Street Stock Series - 2026 Season 4 Fixed",
  "DIRTcar Limited Late Model Series - 2026 Season 4 Fixed",
  "DIRTcar Pro Late Model Series - 2026 Season 4",
  "DIRTcar Pro Late Model Series - Fixed - 2026 Season 4",
  "DIRTcar Street Stock Rookie by IMB Racewear - 2026 Season 4",
  "DIRTcar UMP Modified Series - 2026 Season 4",
  "DIRTcar UMP Modified Series - Fixed - 2026 Season 4",
  "Dallara DW12 Dash - 2026 Season 4",
  "Dallara Formula iR - 2026 Season 4",
  "Dirt 410 Sprint Car Tour - 2026 Season Fixed",
  "Dirt Legends Cup - 2026 Season 4",
  "Dirt Midget Cup - 2026 Season 4",
  "Dirt Midget Cup - Fixed - 2026 Season 4",
  "Dirt Mini Stock Rookie Series - 2026 Season 4",
  "Dirt Super Late Model Tour - 2026 Season Fixed",
  "Draft Master Challenge by Simagic - 2026 Season 4",
  "FIA Cross Car Championship - 2026 Season 4",
  "FIA F4 Esports Regional Tour - America - 2026 Season 4",
  "FIA F4 Esports Regional Tour - Asia Pacific - 2026 Season 4",
  "FIA F4 Esports Regional Tour - Europe - 2026 Season 4",
  "FIA Formula 4 Challenge - Fixed - 2026 Season 4",
  "Ferrari 296 Challenge 2026 Season 4",
  "Ford Mustang Challenge by Skip Barber - 2026 Season 4",
  "Formula 1600 Rookie Series by Asetek Racing - 2026 Season 4",
  "Formula A - Cosworth Cup Grand Prix - 2026 Season 4",
  "Formula A - Cosworth Cup Grand Prix - Fixed - 2026 Season 4",
  "Formula A - Grand Prix Tour - Fixed - 2026 Season ",
  "Formula B - Super Formula Series - Fixed - 2026 Season 4",
  "Formula B - Super Formula Series 2026 Season 4",
  "Formula C -  Dallara F3 Series - 2026 Season 4",
  "Formula C - Dallara F3 Series -2026 Season 4 - Fixed",
  "Formula C - Super Formula Lights - Fixed by RSS - 2026 Season 4",
  "Formula C - Super Formula Lights by RSS - 2026 Season 4",
  "Formula Vee Series by trophi.ai - 2026 Season 4",
  "GT Endurance Series by Simucube - 2026 Season 4",
  "GT Sprint Series by Simucube - 2026 Season 4",
  "GT3 Challenge Fixed by Fanatec - 2026 Season 4",
  "GT4 Falken Tyre Challenge - 2026 Season 4",
  "GTE Sprint Series - 2026 Season 4",
  "Global Endurance Tour - 2026 Season 4",
  "Global Mazda MX-5 Cup by Fanatec - 2026 Season 4",
  "Global Sports Car Challenge by Fanatec - 2026 Season 4",
  "IMSA Endurance Series - 2026 Season 4",
  "IMSA Michelin Pilot Challenge - 2026 Season 4",
  "IMSA Sportscar Endurance Challenge - 2026 Season 4",
  "IMSA Vintage Series - 2026 Season 4",
  "IMSA iRacing Series - Fixed by GO Fast - 2026 Season 4",
  "IMSA iRacing Series by GO Fast - 2026 Season 4",
  "INDYCAR Series - 2026 Season 4",
  "INDYCAR Series - Fixed - 2026 Season 4",
  "INDYCAR Series - Oval - Fixed - 2026 Season 4",
  "Indy NXT Oval Series - Fixed - 2026 Season 4",
  "Indy NXT Road Series - Fixed - 2026 Season 4",
  "Jr Open Wheel Oval Challenge - 2026 Season 4",
  "LMP2 Challenge  - 2026 Season 4 - Fixed",
  "LMP3 Trophy - 2026 Season 4",
  "Legends Cup by Go Motorsports Shop - 2026 Season 4",
  "Legends Road Cup by Go Motorsports Shop - 2026 Season 4",
  "Lotus 49 Grand Prix Legends - 2026 Season 4",
  "Micro Non Wing Sprint Car Rookie Series - 2026 Season 4",
  "Micro Winged Sprint Car Rookie by Thrustmaster - 2026 Season 4",
  "Mini Stock Rookie Series by Thrustmaster - 2026 Season 4",
  "Mission R Challenge - 2026 Season 4",
  "Motorsport UK FF 1600 Trophy by Thrustmaster - 2026 Season 4",
  "NASCAR 1987 Legends Cup  - 2026 Season 4 Fixed",
  "NASCAR Carburetor Cup - 2026 Season 4",
  "NASCAR Class A Series - 2026 Season 4",
  "NASCAR Class A Series - Fixed - 2026 Season 4 Fixed",
  "NASCAR Class C Series - Fixed - 2026 Season 4",
  "NASCAR Euro Series 2026 Season 4",
  "NASCAR Gen 4 Cup Series - 2026 Season 4 Fixed",
  "NASCAR Gen 4 Grand National Series - 2026 Season 4 Fixed",
  "NASCAR Modified Tour - 2026 Season Fixed",
  "NASCAR O'Reilly Auto Parts Series - Fixed - 2026 Season 4",
  "NASCAR Pickup Cup - 2026 Season 4",
  "NASCAR Tour Modified Series - 2026 Season 4",
  "NASCAR Tour Modified Series - Fixed - 2026 Season 4 - Fixed",
  "NASCAR iRacing Class B Series Series - 2026 Season",
  "NASCAR iRacing Class C Series Series - 2026 Season",
  "NASCAR iRacing Series - 2026 Season Fixed",
  "NASCAR iRacing Series - 2026 Season Open",
  "Nurburgring Endurance Championship - 2026 Season",
  "Outlaw Micro Showdown - 2026 Season 4",
  "Porsche Esports Supercup Global Open Qualifiers",
  "Pro 2 Lite Off-Road Rookie Series - 2026 Season 4",
  "Pro 2 Off-Road Series - Fixed - 2026 Season 4",
  "Pro 4 Off-Road Series - Fixed - 2026 Season 4",
  "Production Car Challenge by Sim-Lab - 2026 Season 4",
  "Production Endurance Challenge - 2026 Season 4",
  "Proto-GT Challenge  2026 Season 4",
  "Prototype Challenge  - 2026 Season 4 - Fixed",
  "Radical Esports Cup - 2026 Season 4",
  "Rain Master Challenge by Podium 1 - 2026 Season 4",
  "Rallycross Series - 2026 Season 4",
  "Rallycross Series - Fixed - 2026 Season 4",
  "Ring Meister by LVRY - 2026 Season 4",
  "Rookie Legends Cup by Simshop - 2026 Season 4",
  "Rookie Street Stock Series by Fanatec - 2026 Season 4 Fixed",
  "SK Modified Series - 2026 Season 4 - Fixed",
  "SK Modified Weekly Series - 2026 Season 4",
  "SRX Series - Fixed - 2026 Season 4",
  "Silver Crown Cup - 2026 Season 4",
  "Skip Barber Race Series - 2026 Season 4",
  "Spec Racer Ford Challenge - 2026 Season 4",
  "Sports Car Challenge by Falken Tyre - 2026 Season 4",
  "Sprint Car Cup - 2026 Season 4",
  "Stock Car Brasil - 2026 Season 4",
  "Street Stock Series by Next Level Racing - 2026 Season 4",
  "Super Late Model Series - 2026 Season 4",
  "Super Late Model Series - 2026 Season 4 - Fixed",
  "Super Late Model Tour - 2026 Season Fixed",
  "Supercars Series - 2026 Season 4",
  "Supercars Series - Australian Servers - 2026 Season 4",
  "TCR Virtual Challenge - 2026 Season 4",
  "TCR Virtual Challenge - Fixed - 2026 Season 4",
  "Toyota GR86 Cup by SIMAGIC - 2026 Season 4",
  "Track Day - 2026 Season 4",
  "US Open Wheel D - USF 2000 Series  - 2026 Season 4 - Fixed",
  "USAC 360 Sprint Car Series - 2026 Season 4",
  "VW Lite iRX Rookie Series - 2026 Season 4",
  "Vintage Grand Prix Tour - 2026 Season ",
  "World of Outlaws Late Model Series - 2026 Season 4",
  "World of Outlaws Late Model Series - 2026 Season 4 - Fixed",
  "World of Outlaws Sprint Car Series - 2026 Season 4",
  "World of Outlaws Sprint Car Series - 2026 Season 4 - Fixed",
  "iRX Volkswagen Beetle Lite Series - 2026 Season 4",
  "iRacing DTM Series - 2026 Season ",
  "iRacing Formula A - Grand Prix Tour - 2026 Season ",
  "iRacing GT3 Regional Tour by Sensit! - Americas - 2026 Season 4",
  "iRacing GT3 Regional Tour by Sensit! - Europe - 2026 Season 4",
  "iRacing GT3 Regional Tour by Sensit! -AsiaPacific- 2026 Season 4",
  "iRacing Lotus 79 Grand Prix Series- 2026 Season 4",
  "iRacing Porsche Cup - Fixed by CONSPIT - 2026 Season 4",
  "iRacing Porsche Cup by CONSPIT - 2026 Season 4"
].sort();
